var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F7F6F6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22839 12.793H11.8106V20.5991H9.22839V12.793Z",
    fill: "#FEFEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4745 12.5352C17.3423 12.5352 16.6671 12.9523 15.952 13.8659V12.7934H13.3698V20.5995H15.9717V16.3687C15.9717 15.4748 16.4285 14.6009 17.4614 14.6009C18.4942 14.6009 19.1099 15.4748 19.1099 16.3488V20.5995H21.7121V16.1702C21.7121 13.0913 19.6264 12.5352 18.4745 12.5352Z",
    fill: "#FEFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5295 9C9.67544 9 9 9.61569 9 10.3706C9 11.1255 9.67544 11.7412 10.5295 11.7412C11.3835 11.7412 12.059 11.1255 12.059 10.3706C12.059 9.61569 11.3835 9 10.5295 9Z",
    fill: "#FEFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.befcfaf7.svg";
export { ForwardRef as ReactComponent };